// @noflow
import { Background, ClickableArea, DashLine, IconGroup, Line } from './style';

import PropTypes from 'prop-types';
import * as React from 'react';

const getIcon = (iconType, size, isSelected) =>
    ({
        [true]: null,
        [iconType === 'COPY']: (
            <IconGroup isSelected={isSelected}>
                <Line d={`M${-size / 4} ${-size * 3 / 8} h ${size * 5 / 8} v ${size * 7 / 8} h ${-size * 5 / 8} Z`} />
                <Line d={`M${-size * 3 / 8} ${size * 3 / 8} v ${-size * 7 / 8} h ${size * 5 / 8}`} />
                <DashLine d={`M${size / 4} ${-size * 3 / 8} v ${size * 6 / 8} h ${-size * 4 / 8}`} />
            </IconGroup>
        ),
        [iconType === 'MINUS']: (
            <IconGroup isSelected={isSelected}>
                <Line d={`M${-size / 2} 0 h ${size}`} />
            </IconGroup>
        ),
        [iconType === 'PLUS']: (
            <IconGroup isSelected={isSelected}>
                <Line d={`M${-size * 0.5} 0 h ${size}`} />
                <Line d={`M0 ${-size * 0.5} v ${size}`} />
            </IconGroup>
        )
    }[true]);

Icon.propTypes = {
    changeMode: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
    size: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    xPos: PropTypes.number.isRequired,
    yPos: PropTypes.number.isRequired
};

export default function Icon({ changeMode, isSelected, size, type, xPos, yPos }) {
    return (
        <g transform={`translate(${xPos} ${yPos})`}>
            <Background
                height={size}
                isSelected={isSelected}
                rx={size * 0.5}
                ry={size * 0.5}
                width={size}
                x={-size * 0.5}
                y={-size * 0.5}
            />
            {getIcon(type, size, isSelected)}
            <ClickableArea
                data-qa={`schedule-${type}`.toLowerCase()}
                height={size}
                onClick={changeMode}
                width={size}
                x={-size * 0.5}
                y={-size * 0.5}
            />
        </g>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/control-panel/icon/component.js